import Kelas from "../../../../../components/categories/siakad/lms/data_kelas/Home";
export default function Home() {
  
  return (
    <Kelas />
  );
}
